// extracted by mini-css-extract-plugin
module.exports = {"button":"_127nRW","buttonIcon":"_1ZVjeH"};